"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _mediaQuery = _interopRequireDefault(require("@kiwicom/orbit-components/lib/utils/mediaQuery"));
var _ButtonLink = _interopRequireDefault(require("@kiwicom/orbit-components/lib/ButtonLink"));
var _Mobile = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Mobile"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// This override is necessary to ensure we don't have a margin on the left of the icon
// when we're on desktop viewports.
const ButtonLinkOverride = /*#__PURE__*/_styledComponents.default.a.withConfig({
  displayName: "Link__ButtonLinkOverride",
  componentId: "sc-tqyqae-0"
})(["", ""], _mediaQuery.default.desktop((0, _styledComponents.css)(["div > div{margin:0;}"])));
const Link = ({
  active,
  link,
  icon,
  children,
  rel,
  external
}) => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ButtonLink.default, {
    asComponent: ButtonLinkOverride,
    iconLeft: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Mobile.default, {
      children: icon
    }),
    compact: true,
    type: active ? "primary" : "secondary",
    href: link,
    external: external,
    rel: rel,
    children: children
  });
};
var _default = Link;
exports.default = _default;